<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div v-if="isLoading" class="loader-overlay">
            <div class="spinner"></div>
        </div>
        <div>
            <b-modal id="modal" :title="referralNote" ref="referral-modal">
                <div class="row">
                    <div class="col-md-12">
                        <p class="mb-3">{{ modalContent }}</p>
                    </div>
                </div>
            </b-modal>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-1">{{ $t('View_Users.Users') }}</h4>
                        <div class="search-bar mb-0 search-bar-style">
                            <!-- <b>{{ $t('common.search') }}: </b> -->
                            <input style="border: 1px solid #dcdfe6;" type="text" v-model="serverParams.search"
                                @input="onSearch" :placeholder="$t('common.search_placeholder')" />
                        </div>
                    </div>
                    <div class="card-body">
                        <vue-good-table mode="remote" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :pagination-options="{
                                enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], nextLabel: this.$t('pagination.next'),
                                prevLabel: this.$t('pagination.Previous'),
                                rowsPerPageLabel: this.$t('pagination.rowsPerPage'),
                                ofLabel: this.$t('pagination.of'),
                            }" :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">

                                <span v-if="props.column.field == 'name'">
                                    <span> {{ props.row.name }}</span>
                                </span>
                                <span v-if="props.column.field == 'email'">
                                    <span> {{ props.row.email }}</span>
                                </span>
                                <span v-if="props.column.field == 'mobile_phone'">
                                    <span> {{ props.row.mobile_phone }}</span>
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap">

                                    <!-- <b-button size="sm" @click="editProperty(props.row)"
                                        class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button> -->
                                    <button size="sm" @click="deleteUser(props.row.id)"
                                        class="btn mr-1 new-del-btn custom-btn">
                                        <!-- {{ $t('properties_list.Delete') }} -->
                                        <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M13.7483 3.50285H9.41832V2.72285C9.41832 1.73285 8.60832 0.922852 7.61832 0.922852C6.62832 0.922852 5.81832 1.73285 5.81832 2.72285V3.50285H1.49832C0.82832 3.50285 0.27832 4.04285 0.27832 4.72285C0.27832 5.40285 0.81832 5.94285 1.49832 5.94285H13.7583C14.4283 5.94285 14.9783 5.39285 14.9783 4.72285C14.9783 4.05285 14.4283 3.50285 13.7583 3.50285H13.7483ZM1.41832 17.5029C1.41832 18.7229 2.40832 19.7029 3.61832 19.7029H11.6183C12.8383 19.7029 13.8183 18.7129 13.8183 17.5029V7.31285H1.41832V17.5029ZM8.78832 10.2529C8.78832 9.83285 9.12832 9.49285 9.54832 9.49285C9.96832 9.49285 10.3083 9.83285 10.3083 10.2529V16.7229C10.3083 17.1429 9.96832 17.4829 9.54832 17.4829C9.12832 17.4829 8.78832 17.1429 8.78832 16.7229V10.2529ZM4.93832 10.2529C4.93832 9.83285 5.27832 9.49285 5.69832 9.49285C6.11832 9.49285 6.45832 9.83285 6.45832 10.2529V16.7229C6.45832 17.1429 6.11832 17.4829 5.69832 17.4829C5.27832 17.4829 4.93832 17.1429 4.93832 16.7229V10.2529Z" fill="#FF4747"></path></svg>
                                    </button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api';
import moment from 'moment';
import Swal from 'sweetalert2';

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            searchTime: null,
            isDisabled: false,
            referralNote: 'Referral Note',
            modalContent: '',
            selected: true,
            unSelected: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Name',
                    field: 'name',
                    filterable: false,
                },
                {
                    label: 'Email',
                    field: 'email',
                    sortable: false,
                },

                {
                    label: 'Phone',
                    field: "mobile_phone",
                    sortable: false,
                },
                {
                    label: this.$t('properties_list.action'),
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        updateColumnLabels() {
            this.columns.forEach(col => {
                switch (col.field) {
                    case 'name':
                        col.label = this.$t('View_Users.name');
                        break;
                    case 'email':
                        col.label = this.$t('View_Users.email');
                        break;
                    case 'mobile_phone':
                        col.label = this.$t('View_Users.phone');
                        break;
                    case 'action':
                        col.label = this.$t('properties_list.action');
                        break;
                    default:
                        break;
                }
            });
        },
        loadItems() {
            this.isLoading = true;
            API.getAllusers(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        onSearch() {
            // Debounce the search to prevent too many API calls
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.serverParams.page = 1;
                this.loadItems();
            }, 500);
        },
        deleteUser(id) {
            this.$swal({
                title: this.$t('sweetalert.Are_you_sure?'),
                text: this.$t('sweetalert.no_revert'),
                type: 'warning',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('sweetalert.yes'),
                cancelButtonText: this.$t('sweetalert.cancel')
            }).then((result) => {
                if (result.value == true) {
                    API.deleteUser(id, res => {
                        this.loadItems();
                    }, err => {
                        console.log(err);
                    })
                }
            })
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    },
    computed: {
        name() {
            return this.$t('View_Users.name');
        },
        email() {
            return this.$t('View_Users.email');
        },
        phone() {
            return this.$t('View_Users.phone');
        },
        action() {
            return this.$t('properties_list.action');
        },
    },
    mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        this.loadItems();
        this.updateColumnLabels();
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            this.columns.find(col => col.field === 'name').label = this.name;
            this.columns.find(col => col.field === 'email').label = this.email;
            this.columns.find(col => col.field === 'mobile_phone').label = this.phone;
        }
    }
}
</script>